export default (resolve) => {
  const FAKE_FETCH_TIMEOUT = 0;
  let updateResponse = null;
  let done = null;
  let then = null;
  let fail = null;
  let always = null;

  setTimeout(() => {
    resolve(response => {
      if (done) {
        done(response)
      }
    })
  }, FAKE_FETCH_TIMEOUT);

  return {
    updateResponse: function (updateResponseFn) {
      updateResponse = updateResponseFn;

      return this;
    },
    done: function (doneFn) {
      done = doneFn;

      return this;
    },
    then: function (doneFn) {
      done = doneFn;

      return this;
    },
    'catch': function (failFn) {
      fail = failFn;

      return this;
    },
    fail: function (failFn) {
      fail = failFn;

      return this;
    },
    always: function (alwaysFn) {
      always = alwaysFn;

      return this;
    }
  };
};
